import { useRouter, useNavigate, useCanGoBack } from '@tanstack/react-router';

/**
 * Custom hook for handling back navigation logic
 * Provides consistent back navigation behavior across the app
 */
export function useBackNavigation(backTo?: string, fallbackTo = '/') {
  const router = useRouter();
  const navigate = useNavigate();
  const canGoBack = useCanGoBack();

  const handleBack = () => {
    // If a specific route is provided, navigate there
    if (backTo) {
      navigate({ to: backTo });
      return;
    }

    if (canGoBack) {
      // Use browser history for natural navigation
      // This respects the user's actual navigation flow
      router.history.back();
    } else {
      // Fallback for direct deep links/push opens with no in-app history
      navigate({ to: fallbackTo });
    }
  };

  return handleBack;
}
